class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    //document.querySelector('#smile-ui-lite-container').style.display = "none";
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active'); });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    //document.querySelector('#smile-ui-lite-container').style.display = "block";
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    if (typeof initUpsellSlider === "function") {
      initUpsellSlider();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class DeployerSuperiorOffer extends HTMLElement {
  constructor() {
    super();

    this.currentVariantId = this.dataset.currentVariantId;
    this.lineItemKey = this.dataset.lineItemKey;
    this.productId = this.dataset.productId;
    this.addButton = this.querySelector('#add-button');

    this.refreshSuperiorVariant();

    this.superiorOfferPercent = this.querySelector('#superior-offer-percent');
    this.superiorOfferQuantity = this.querySelector('#superior-offer-quantity');
    this.superiorOfferPriceToWeight = this.querySelector('#superior-offer-price-to-weight');

    this.currencyFormatter = new Intl.NumberFormat(window.Shopify.locale, {
      style: 'currency',
      currency: window.Shopify.currency.active,
    });
  }

  /**
   * Fetch all product variants
   */
  async fetchProductVariants() {
    const product = await fetch(`/products/${this.productId}.js`).then(res => res.json());
    this.variants = product.variants;
  }

  /**
   * Refresh superior variant
   */
  async refreshSuperiorVariant() {
    if (!this.variants) {
      await this.fetchProductVariants();
    }

    const currentVariantIndex = this.variants.findIndex(variant => variant.id === parseInt(this.currentVariantId));
    const currentVariant = this.variants[currentVariantIndex];
    const superiorVariant = this.variants[currentVariantIndex + 1];

    if (!superiorVariant) {
      this.hide();
      return;
    }

    const currentPriceToWeight = currentVariant.price / currentVariant.weight;
    const superiorPriceToWeight = superiorVariant.price / superiorVariant.weight;

    const priceToWeightDiffPercent = Math.round(100 - superiorPriceToWeight * 100 / currentPriceToWeight); // percent

    this.renderSuperiorVariant(superiorVariant.weight, priceToWeightDiffPercent);
    this.superiorVariantId = superiorVariant.id;
  }

  /**
   * Render superior variant
  */
  renderSuperiorVariant(weight, priceToWeightDiffPercent) {
    this.superiorOfferPercent.innerHTML = `Passe à <strong>${weight}g</strong> et économise <strong>${this.currencyFormatter.format(1 + priceToWeightDiffPercent / 100 * weight)}/g</strong> !`;
  }

  /**
   * Hide superior offer
   */
  hide() {
    this.classList.add('hidden');
  }

  connectedCallback() {
    if (this.addButton) {
      this.addButton.addEventListener('click', this.handleAddClick.bind(this));
    }
  }

  /**
   * Remove current variant from cart and add superior variant
   * 
   * Then re-render the cart
   */
  async handleAddClick(e) {
    e.preventDefault();

    if (this.superiorVariantId && this.currentVariantId && this.lineItemKey) {
      if (this.addButton.querySelector('.loading__spinner')) {
        this.addButton.classList.add('loading');
        this.addButton.querySelector('.loading__spinner').classList.remove('hidden');
      }
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: this.lineItemKey,
            quantity: 0,
          })
        });

        const cart = document.querySelector('cart-drawer');

        const formData = new FormData();
        formData.append('form_type', 'product');
        formData.append('product-id', this.productId);
        formData.append('id', this.superiorVariantId);
        formData.append('quantity', 1);
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);

        const cartData = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        }).then(res => res.json());

        this.currentVariantId = this.superiorVariantId;
        this.refreshSuperiorVariant();

        cart.renderContents(cartData);
      } catch (error) {
        console.error('Error upgrading variant:', error);
      }
    }
  }
}

customElements.define('deployer-superior-offer', DeployerSuperiorOffer);